import { render, staticRenderFns } from "./qr-code-form.vue?vue&type=template&id=b6f1f7c6&"
import script from "./qr-code-form.vue?vue&type=script&lang=js&"
export * from "./qr-code-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports